import { defineMessages } from 'react-intl';

export const widgetMessages = defineMessages({
  questionWidgetCaption: {
    id: 'question_widget.caption',
  },
  questionWidgetCaptionMultiple: {
    id: 'question_widget.caption_multiple',
  },
  questionWidgetIncorrectTryMessage: {
    id: 'question_widget.incorrect_try_message',
  },
  questionWidgetIncorrectNoRetry: {
    id: 'question_widget.incorrect_no_retry',
  },
  questionWidgetCorrectTryMessage: {
    id: 'question_widget.correct_try_message',
  },
  hiddenAreaWidgetLocateOnScene: {
    id: 'hidden_area_widget.locate_on_scene',
  },
  hiddenAreaWidgetLocateButton: {
    id: 'hidden_area_widget.locate_button',
  },
  hiddenAreaWidgetWellDone: {
    id: 'hidden_area_widget.well_done',
  },
  hiddenAreaWidgetSuccessMessage: {
    id: 'hidden_area_widget.success_message',
  },
  sortationWidgetCaption: {
    id: 'sortation_widget.caption',
  },
  questionWidgetPartiallyIncorrectMarkedWrong: {
    id: 'question_widget.partially_incorrect_marked_wrong',
  },
  questionWidgetPartiallyIncorrectMissingOptions: {
    id: 'question_widget.partially_incorrect_missing_options',
  },
  questionWidgetPartiallyIncorrectMissingAndWrongOptions: {
    id: 'question_widget.partially_incorrect_missing_and_wrong_options',
  },
  fillInWidgetFillInAnswer: {
    id: 'fill_in_widget.fill_in_answer',
  },
  fillInWidgetAcceptedAnswers: {
    id: 'fill_in_widget.accepted_answers',
  },
  pdfWidgetViewPdf: {
    id: 'pdf_widget.view_pdf',
  },
});
